/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  if ($("#company_widget_form").length > 0) {
    aspectsAutocomplete();
    manufacturersAutocomplete();
    collectionsAutocomplete();
    return productMultiSelect();
  }
});

this.productMultiSelect = function() {
  $('select[id^=product_multi_select_]').selectize({
    create: false,
    sortField: 'text',
    persist: false,
    maxItems: 20
  });

  return $('select[id^=product_multi_select_allow_new_value_]').selectize({
    create: true,
    sortField: 'text',
    persist: false,
    maxItems: 20
  });
};

this.manufacturersAutocomplete = () => $('#company_widget_manufacturer').selectize({
  create: true,
  sortField: 'text'
});

this.collectionsAutocomplete = () => $('#company_widget_collection').selectize({
  create: true,
  sortField: 'text'
});

this.aspectsAutocomplete = function() {
  $('#company_product_aspect_name').selectize({
    create: true,
    sortField: 'text'
  });
  return $('#company_product_aspect_values').selectize({
    create: true,
    plugins: ['restore_on_backspace','remove_button','drag_drop']});
};